/**
 *
 * key
 *
 */


const key = 'b2ZmZXI='

export default key